module.exports = __webpack_public_path__ + "media/tile-1-overlay.780741e5.webp";